import { useEffect, useState } from "react";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import Model from "../../common/Model/index.js";
import CRMSelect from "../../common/CustomSelect/CRMSelect.jsx";
import { notify } from "../../common/Toast/index.js";
import { FaStarOfLife } from "react-icons/fa";

const MaterialItemTable = ({
  items,
  handleItemDelete,
  allItems,
  setItems,
  coatingColors,
  handleItemSelect,
  selectedCoatingPartyId,
  isCoatingModalOpen,
  setIsCoatingModalOpen,
  setCoatingColors,
  setIsItemModalOpen,
  isItemModalOpen,
  setAllItems,
  fetchDropdownData,
  errors,
  permission,
}) => {
  const userId = localStorage.getItem("userId");

  const [newCoatingColor, setNewCoatingColor] = useState({
    coating_Color_Name: "",
    coating_Color_Code: "",
  });
  const [isItemType, setIsItemType] = useState([]);
  const [isCoilData, setIsCoilData] = useState([]);
  const [isEditingCoatingColor, setIsEditingCoatingColor] = useState(false);
  const [editCoatingColorId, setEditCoatingColorId] = useState(null);
  const [newItem, setNewItem] = useState({
    item_Code: 0,
    item_Name: "",
    description: "",
    item_Rate: 0,
    item_Face: 0,
    item_Type: "",
    coil_Used: "",
    thickness: 0,
    image: null,
  });

  const filteredCoatingColors = coatingColors.filter(
    (color) => color.coating_Party_Id === Number(selectedCoatingPartyId)
  );

  const handleAddOrUpdateCoatingColor = async () => {
    try {
      const payload = {
        Coating_Color_Id: isEditingCoatingColor ? editCoatingColorId : 0,
        Coating_Party_Id: Number(selectedCoatingPartyId),
        Coating_Color_Name: newCoatingColor.coating_Color_Name,
        Coating_Color_Code: newCoatingColor.coating_Color_Code,
      };

      const apiUrl = isEditingCoatingColor
        ? "MaterialQuotation/UpdateCoatingColor"
        : "MaterialQuotation/SaveCoatingColor";

      const response = await axiosInstance.post(apiUrl, payload);

      notify(
        isEditingCoatingColor
          ? "Coating Color updated successfully!"
          : "Coating Color added successfully!",
        "success"
      );

      fetchDropdownData(
        "MaterialQuotation/GetAllCoatingColors",
        setCoatingColors
      );
      if (isEditingCoatingColor) {
        setItems((prevItems) =>
          prevItems.map((item) =>
            item.coating_Color_Id === editCoatingColorId
              ? { ...item, coating_Color_Id: editCoatingColorId }
              : item
          )
        );
      }

      setIsCoatingModalOpen(false);
      setNewCoatingColor({ coating_Color_Name: "", coating_Color_Code: "" });
      setIsEditingCoatingColor(false);
      setEditCoatingColorId(null);
    } catch (error) {
      console.error("Error adding/updating coating color:", error);
    }
  };

  const handleCoatingColorEdit = async (id) => {
    try {
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetCoatingColorById/${id}`
      );
      setNewCoatingColor({
        coating_Color_Name: data.coating_Color_Name,
        coating_Color_Code: data.coating_Color_Code,
      });
      setEditCoatingColorId(id);
      setIsEditingCoatingColor(true);
      setIsCoatingModalOpen(true);
    } catch (error) {
      console.error("Error fetching coating color:", error);
    }
  };

  const fetchItemType = async () => {
    if (isItemType.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetAllItemType`);
      setIsItemType(res.data);
    } catch (error) {
      console.error("Error fetching GetAllItemType:", error);
    }
  };
  const fetchCoilData = async () => {
    if (isCoilData.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetCoilMaster`);
      setIsCoilData(res.data);
    } catch (error) {
      console.error("Error fetching GetCoilMaster:", error);
    }
  };
  useEffect(() => {
    fetchItemType();
    fetchCoilData();
  }, []);

  const handleInputChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };
  const fetchItemsData = async () => {
    try {
      const response = await axiosInstance.get("Item/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("Item_Code", newItem.item_Code || 0);
    formDataToSend.append("Item_Name", newItem.item_Name);
    formDataToSend.append("Description", newItem.description);
    formDataToSend.append("Item_Rate", newItem.item_Rate);
    formDataToSend.append("Item_Type", parseInt(newItem.item_Type) || 0);
    formDataToSend.append("Item_Face", Number(newItem.item_Face));
    formDataToSend.append("Coil_Used", parseInt(newItem.coil_Used) || 0);
    formDataToSend.append("Thickness", Number(newItem.thickness));

    if (newItem.image) {
      formDataToSend.append("image", newItem.image);
    }

    try {
      await axiosInstance.post("Item/SaveUpdate", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      fetchItemsData();
      setIsItemModalOpen(false);
      notify("Item added successfully!", "success");
      setNewItem({
        item_Code: "",
        item_Name: "",
        description: "",
        item_Rate: "",
        item_Type: "",
        item_Face: "",
        coil_Used: "",
        thickness: "",
        image: null,
      });

      document.getElementById("fileInput").value = "";
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };
  const itemOptions = [
    ...allItems?.map((item) => ({
      value: item.item_Code?.toString() || "",
      label: item.item_Name || "Unnamed Item",
    })),
    { value: "add-newItem", label: "+ Add New Item" },
  ];
  const colorOptions = [
    ...filteredCoatingColors.map((color) => ({
      value: color.coating_Color_Id,
      label: `${color.coating_Color_Name} `,
    })),
    { value: "add-new", label: "+ Add New Coating Color" },
  ];


  return (
    <>
      <div className="bg-white rounded-3xl border border-slate-100 overflow-hidden mt-6 shadow-sm relative">
        <div className="bg-slate-50/50 px-6 py-4 border-b border-slate-100 flex justify-between items-center">
          <h2 className="text-[11px] font-black text-slate-700 uppercase tracking-widest flex items-center gap-2">
            Item Materials & Details
            <span className="bg-primary/10 text-primary text-[9px] px-2 py-0.5 rounded-full ml-1 font-bold">
              {items?.length || 0}
            </span>
          </h2>
          <button
            type="button"
            className="text-[9px] font-black text-primary bg-primary/10 px-4 py-1.5 rounded-full hover:bg-primary hover:text-white transition-all active:scale-95 shadow-sm uppercase tracking-widest"
            onClick={() =>
              setItems((prevItems) => [
                ...prevItems,
                {
                  item_Code: "",
                  item_Name: "",
                  coating_Color_Id: "",
                  panel_Size: "",
                  qty: "",
                  total_RfT: 0,
                  rate: 0,
                  amount: 0,
                  seQ_NO: prevItems.length + 1,
                },
              ])
            }
          >
            + ADD ITEM
          </button>
        </div>
        <div className="w-full overflow-x-auto">
          <table className="w-full text-left border-separate border-spacing-0">
            <thead>
              <tr className="bg-slate-50/30">
                <th className="px-6 py-3.5 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100 w-16">No</th>
                <th className="px-6 py-3.5 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100 min-w-[280px]">Product details</th>
                <th className="px-6 py-3.5 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100 min-w-[220px]">Coating specs</th>
                <th className="px-6 py-3.5 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100 min-w-[180px]">Qty / Sizing</th>
                <th className="px-6 py-3.5 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100">Financials</th>
                <th className="px-6 py-3.5 text-right text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100 w-24">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {items.map((item, index) => (
                <tr key={index} className="group hover:bg-slate-50/30 transition-all text-sm">
                  <td className="px-6 py-4 font-bold text-slate-400 align-top pt-6">{item.seQ_NO}</td>
                  <td className="px-6 py-4 align-top">
                    <div className="flex flex-col gap-2">
                      <CRMSelect
                        options={itemOptions}
                        value={itemOptions.find(opt => String(opt.value) === String(items[index]?.item_Code)) || null}
                        menuPortalTarget={document.body}
                        isClearable
                        isSearchable
                        placeholder="Select Product..."
                        onChange={(opt) => {
                          if (opt?.value === "add-newItem") {
                            setIsItemModalOpen(true);
                          } else {
                            handleItemSelect(index, opt, "item_Code");
                          }
                        }}
                      />
                      <p className="text-[10px] text-slate-400 ml-1 font-medium tracking-wide">Product details</p>
                    </div>
                  </td>
                  <td className="px-6 py-4 align-top">
                    <div className="space-y-1">
                      <div className="flex items-center gap-2">
                        <div className="flex-1">
                          <CRMSelect
                            options={colorOptions}
                            value={colorOptions.find(opt => opt.value === items[index]?.coating_Color_Id) || null}
                            menuPortalTarget={document.body}
                            isClearable
                            isSearchable
                            placeholder="Select Color..."
                            onChange={(opt) => handleItemSelect(index, opt, "coating_Color_Id")}
                          />
                        </div>
                        {items[index]?.coating_Color_Id && (
                          <button
                            type="button"
                            onClick={() => handleCoatingColorEdit(items[index]?.coating_Color_Id)}
                            className="p-2 text-primary bg-primary/5 rounded-lg hover:bg-primary hover:text-white transition-all"
                          >
                            <MdModeEdit size={16} />
                          </button>
                        )}
                      </div>
                      <p className="text-[10px] text-slate-400 ml-1 font-medium tracking-wide">Coating Color</p>
                    </div>
                  </td>
                  <td className="px-6 py-4 align-top">
                    <div className="grid grid-cols-2 gap-2">
                      <div className="flex flex-col gap-1">
                        <label className="text-[9px] font-bold text-slate-300 uppercase tracking-tighter ml-1">Panel MM</label>
                        <input
                          className="w-full bg-slate-50 border border-slate-200 rounded-lg px-2 py-1.5 text-xs font-bold text-slate-600 outline-none focus:bg-white focus:border-primary transition-all"
                          name="panel_Size"
                          value={items[index]?.panel_Size || ""}
                          onChange={(e) => handleItemSelect(index, e)}
                        />
                      </div>
                      <div className="flex flex-col gap-1">
                        <label className="text-[9px] font-bold text-slate-300 uppercase tracking-tighter ml-1">Qty</label>
                        <input
                          className="w-full bg-slate-50 border border-slate-200 rounded-lg px-2 py-1.5 text-xs font-bold text-slate-600 outline-none focus:bg-white focus:border-primary transition-all"
                          name="qty"
                          value={items[index]?.qty || ""}
                          onChange={(e) => handleItemSelect(index, e)}
                        />
                      </div>
                      <div className="col-span-2 mt-1">
                        <div className="bg-slate-50/50 border border-slate-100/50 rounded-lg px-3 py-1.5 flex justify-between items-center">
                          <span className="text-[10px] font-bold text-slate-400">Total RfT</span>
                          <span className="text-xs font-black text-slate-600 font-mono">{item.total_RfT.toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 align-top">
                    <div className="flex flex-col gap-2 min-w-[140px]">
                      <div className="relative">
                        <span className="absolute left-3 top-1.5 text-[10px] font-bold text-slate-300">₹</span>
                        <input
                          type="text"
                          className="w-full bg-white border border-slate-200 rounded-lg pl-6 pr-3 py-1.5 font-bold text-slate-700 outline-none focus:border-primary transition-all text-xs"
                          name="rate"
                          value={items[index]?.rate || ""}
                          onChange={(e) => handleItemSelect(index, e)}
                          disabled={userId !== "1" && userId !== "19"}
                        />
                      </div>
                      <div className="flex flex-col items-end px-1">
                        <span className="text-[9px] font-black uppercase text-slate-300 tracking-widest">Line Total</span>
                        <span className="text-lg font-black text-slate-800 tracking-tighter font-mono leading-none mt-1">₹{item.amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-right align-top pt-6">
                    {permission?.isDelete && (
                      <button
                        type="button"
                        className="p-2.5 bg-red-50 text-red-400 rounded-lg hover:bg-red-500 hover:text-white transition-all active:scale-95"
                        onClick={() => handleItemDelete(index, item.item_Code, item.seQ_NO)}
                      >
                        <MdDeleteForever size={18} />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {errors.items && (
          <div className="bg-red-50 px-8 py-3 border-t border-red-100">
            <p className="text-red-500 text-[11px] font-bold flex items-center gap-2 italic">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500"></span> {errors.items}
            </p>
          </div>
        )}
      </div>

      <Model
        isOpen={isCoatingModalOpen}
        onClose={() => setIsCoatingModalOpen(false)}
        name="Add Coating Color"
      >
        <div>
          <div className="space-y-4">
            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Color Name</label>
              <input
                type="text"
                placeholder="e.g. Pure White"
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                value={newCoatingColor.coating_Color_Name}
                onChange={(e) => setNewCoatingColor((prev) => ({ ...prev, coating_Color_Name: e.target.value }))}
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Color Code / RAL</label>
              <input
                type="text"
                placeholder="e.g. RAL 9010"
                className="w-full rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                value={newCoatingColor.coating_Color_Code}
                onChange={(e) => setNewCoatingColor((prev) => ({ ...prev, coating_Color_Code: e.target.value }))}
              />
            </div>
          </div>
          <div className="flex items-center gap-3 pt-4">
            <button
              type="button"
              onClick={handleAddOrUpdateCoatingColor}
              className="flex-1 py-4 bg-primary text-white font-bold rounded-2xl shadow-lg shadow-primary/20 hover:shadow-xl transition-all active:scale-[0.98]"
            >
              {isEditingCoatingColor ? "Update Color" : "Save Color"}
            </button>
            <button
              type="button"
              onClick={() => setIsCoatingModalOpen(false)}
              className="flex-1 py-4 bg-slate-100 text-slate-500 font-bold rounded-2xl hover:bg-slate-200 transition-all active:scale-[0.98]"
            >
              Discard
            </button>
          </div>
        </div>
      </Model>

      <Model
        isOpen={isItemModalOpen}
        onClose={() => setIsItemModalOpen(false)}
        name="Add New Item"
      >
        <div className=" max-h-[80vh] overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="col-span-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                Item Name
                <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
              </label>
              <input
                type="text"
                name="item_Name"
                value={newItem.item_Name || ""}
                onChange={handleInputChange}
                className="w-full mt-2 rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                placeholder="Enter item name"
              />
            </div>

            <div className="col-span-2">
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Description</label>
              <textarea
                name="description"
                value={newItem.description || ""}
                onChange={handleInputChange}
                className="w-full mt-2 rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold resize-none"
                placeholder="Enter technical details..."
                rows={3}
              />
            </div>

            <div>
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1 flex items-center">
                Base Rate
                <FaStarOfLife className="text-red-400 ml-2 w-1.5 h-1.5" />
              </label>
              <input
                type="number"
                name="item_Rate"
                value={newItem.item_Rate || ""}
                onChange={handleInputChange}
                className="w-full mt-2 rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-bold text-lg"
                placeholder="0.00"
              />
            </div>

            <div>
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Item Face</label>
              <input
                type="text"
                name="item_Face"
                value={newItem.item_Face || ""}
                onChange={handleInputChange}
                className="w-full mt-2 rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                placeholder="Face specs"
              />
            </div>

            <div>
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Item Type</label>
              <select
                className="w-full mt-2 h-[54px] rounded-2xl border border-slate-200 bg-white px-5 outline-none focus:border-primary transition-all font-semibold appearance-none cursor-pointer"
                name="item_Type"
                value={newItem.item_Type}
                onChange={handleInputChange}
              >
                <option value="">Select Type</option>
                {isItemType.map((type) => (
                  <option key={type.item_Type} value={type.item_Type}>
                    {type.item_Type_Name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Coil Specification</label>
              <select
                className="w-full mt-2 h-[54px] rounded-2xl border border-slate-200 bg-white px-5 outline-none focus:border-primary transition-all font-semibold appearance-none cursor-pointer"
                name="coil_Used"
                value={newItem.coil_Used}
                onChange={handleInputChange}
              >
                <option value="">Select Coil</option>
                {isCoilData.map((coil) => (
                  <option key={coil.coil_Used} value={coil.coil_Used}>
                    {coil.coil_Name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Thickness (MM)</label>
              <input
                type="number"
                name="thickness"
                value={newItem.thickness || ""}
                onChange={handleInputChange}
                className="w-full mt-2 rounded-2xl border border-slate-200 bg-white px-5 py-3.5 outline-none focus:border-primary transition-all font-semibold"
                placeholder="0.00"
              />
            </div>

            <div>
              <label className="text-[11px] font-bold text-slate-400 uppercase tracking-widest ml-1">Product Image</label>
              <input
                type="file"
                name="image"
                className="w-full mt-2 text-xs font-semibold text-slate-400 file:mr-4 file:py-2 file:px-4 file:rounded-xl file:border-0 file:text-xs file:font-black file:bg-primary/10 file:text-primary hover:file:bg-primary/20 transition-all"
                onChange={(e) => setNewItem({ ...newItem, image: e.target.files[0] })}
              />
            </div>
          </div>

          <div className="flex items-center gap-3 pt-6 border-t border-slate-100">
            <button
              type="button"
              onClick={handleSubmit}
              className="flex-1 py-4 bg-primary text-white font-bold rounded-2xl shadow-lg shadow-primary/20 hover:shadow-xl transition-all active:scale-[0.98]"
            >
              Create Product
            </button>
            <button
              type="button"
              onClick={() => setIsItemModalOpen(false)}
              className="flex-1 py-4 bg-slate-100 text-slate-500 font-bold rounded-2xl hover:bg-slate-200 transition-all active:scale-[0.98]"
            >
              Cancel
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default MaterialItemTable;
